import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { hasYesOrNo } from 'models/validate';
import { ForeignBusinessPoliticalItemModel } from '../types';

const foreignBusinessPoliticalItemValidator: ValidateJSModel<ForeignBusinessPoliticalItemModel> = {
  Position: { hasValue: true },

  Dates: (value, attributes, attributeName, options = {}) => ({
    presence: true,
    daterange: { earliest: setToStartOfMonth(options?.applicantBirthdate), latest: DEFAULT_LATEST },
  }),

  Country: (value, attributes) => {
    if (attributes?.CountryFocused) {
      return {};
    }

    return { hasValue: true, country: { excludeUnitedStates: true } };
  },

  Reason: { hasValue: true },

  CurrentlyEligible: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { hasValue: { validator: hasYesOrNo } };
    }

    return {};
  },

  CurrentlyEligibleExplanation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.CurrentlyEligible?.value === 'Yes') {
      return { hasValue: true };
    }

    return {};
  },

  Eligibility: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {};
    }

    return { hasValue: true };
  },
};

export default foreignBusinessPoliticalItemValidator;
